const linkedIn = { column: 'linkedin_url', name: 'LinkedIn URL', type: 'input' }
const resume = {
  column: 'resume_document_id',
  name: 'Candidate Resume',
}

// we may be able to remove this file in the future once select is finalized. Product wants to only show Additional Information input only for now

export function getServiceRequestFields(
  industries = [],
  companySizes = {},
  salaries = [],
) {
  let normalizedCompanySizes = Object.entries(companySizes).map(
    ([label, value]) => ({ label, value }),
  )
  return {
    LinkedInReview: [linkedIn],
    ResumeReview: [
      resume,
      {
        column: 'seniority_level',
        name: 'Seniority Level',
        choices: [
          { label: 'Entry to Mid Level', value: 'Entry to Mid Level' },
          {
            label: 'Manager to Director Level',
            value: 'Manager to Director Level',
          },
          { label: 'VP to C Level', value: 'VP to C Level' },
        ],
      },
      { column: 'example_job_1', name: 'Example Job 1', type: 'input' },
      { column: 'example_job_2', name: 'Example Job 2', type: 'input' },
      { column: 'example_job_3', name: 'Example Job 3', type: 'input' },
      linkedIn,
      { column: 'notes', name: 'Notes', type: 'input' },
      { column: 'remote_content', name: 'Remote Content', type: 'input' },
    ],
    CandidateRevision: [
      {
        column: 'remote_content',
        name: 'Candidate Resume Revision',
        type: 'input',
      },
      { column: 'notes', name: 'Notes', type: 'input' },
    ],
    JobSearchStrategy: [
      {
        column: 'desired_goal',
        name: 'Desired Goal',
        choices: [
          { label: 'Landing a similar job', value: 'new_job' },
          { label: 'Making a career change', value: 'career_change' },
          { label: 'Finding a gig or contract job', value: 'contract_job' },
          { label: 'Working for myself', value: 'working_for_self' },
          { label: 'Retirement', value: 'retirement' },
        ],
      },
      { column: 'desired_timeline', name: 'Desired Timeline' },
    ],
    InterviewPrep: [
      { column: 'target_roles', name: 'Target Roles' },
      { column: 'career_level', name: 'Career Level' },
      {
        column: 'interview_types',
        name: 'Interview Types',
        type: 'multiselect',
      },
    ],
    ExecutiveBio: [
      { column: 'linkedin_url', name: 'LinkedIn URL', type: 'input' },
      { column: 'resume_document_id', name: 'Candidate Resume' },
    ],
    RecruiterGuidanceSupport: [
      { column: 'industry_role', name: 'Industry Role', type: 'input' },
      { column: 'location', name: 'Location', type: 'input' },
      {
        column: 'industry',
        name: 'Industry',
        choices: industries.map((i) => ({ label: i, value: i })),
      },
      {
        column: 'salary',
        name: 'Salary',
        choices: salaries.map((salary) => ({ label: salary, value: salary })),
      },
    ],
    TargetCompanyResearch: [
      { column: 'industry', name: 'Industry', type: 'input' },
      { column: 'industry_2', name: 'Industry 2', type: 'input' },
      {
        column: 'sector',
        name: 'Sector',
        type: 'select',
        choices: [
          { label: 'Any', value: 'Any' },
          { label: 'Public', value: 'Public' },
          { label: 'Private', value: 'Private' },
        ],
      },
      { column: 'example_job_1', name: 'Example Job 1', type: 'input' },
      { column: 'example_job_2', name: 'Example Job 2', type: 'input' },
      {
        column: 'company_size',
        name: 'Company Size',
        type: 'select',
        choices: normalizedCompanySizes.map((company) => ({
          label: company.label,
          value: company.value,
        })),
      },
      { column: 'location', name: 'Location', type: 'input' },
    ],
    TargetedResearch: [
      {
        column: 'targeted_research_type',
        name: 'Research Type',
        choices: [
          { label: 'Company', value: 'company' },
          { label: 'Industry', value: 'industry' },
          { label: 'Company & Industry', value: 'both' },
        ],
      },
    ],
    MockInterview: [
      {
        column: 'target_job_description',
        name: 'Target Job Description',
        type: 'input',
      },
      { column: 'resume_document_id', name: 'Candidate Resume' },
      { column: 'interview_with', name: 'Interview With', type: 'input' },
      { column: 'interview_type', name: 'Interview Type', type: 'input' },
    ],
    CoverLetterReview: [
      {
        column: 'candidate_document',
        name: 'Candidate Document',
      },
      { column: 'resume_document_id', name: 'Candidate Resume' },
      {
        column: 'target_job_description',
        name: 'Target Job Description',
        type: 'input',
      },
    ],
    ResumeTailoring: [
      { column: 'resume_document_id', name: 'Candidate Resume' },
      {
        column: 'target_job_description',
        name: 'Target Job Description',
        type: 'input',
      },
    ],
    ResumeWriting: [
      { column: 'work_experience', name: 'Work Experience' },
      { column: 'education_history', name: 'Education History' },
      {
        column: 'target_job_description',
        name: 'Target Job Description',
      },
      { column: 'resume_document_id', name: 'Candidate Resume' },
      linkedIn,
      { column: 'achievements', name: 'Achievements' },
      {
        column: 'skills_certifications',
        name: 'Skills & Certifications',
      },
    ],
    CareerPivotPlanning: [
      { column: 'most_recent_role', name: 'Most Recent Role' },
      { column: 'desired_role', name: 'Desired Role' },
    ],
    GeneralCheckIn: [
      {
        column: 'general_topic',
        name: 'General Topic',
        choices: [
          { value: 'Career Growth', label: 'Career Growth' },
          { value: 'Work-Life Balance', label: 'Work-Life Balance' },
          { value: 'Job Search', label: 'Job Search' },
          { value: 'Leadership', label: 'Leadership' },
          { value: 'Other', label: 'Other' },
        ],
      },
    ],
    SalaryResearch: [
      { column: 'industry', name: 'Industry', type: 'input' },
      { column: 'industry_2', name: 'Industry 2', type: 'input' },
      {
        column: 'sector',
        name: 'Sector',
        choices: [
          { label: 'Any', value: 'Any' },
          { label: 'Public', value: 'Public' },
          { label: 'Private', value: 'Private' },
        ],
      },
      { column: 'example_job_1', name: 'Example Job 1', type: 'input' },
      { column: 'example_job_2', name: 'Example Job 2', type: 'input' },
      {
        column: 'company_size',
        name: 'Company Size',
        choices: normalizedCompanySizes.map((company) => ({
          label: company.label,
          value: company.value,
        })),
      },
      { column: 'location', name: 'Location', type: 'input' },
    ],
    BusinessCardCreation: [
      { column: 'professional_name', name: 'Professional Name', type: 'input' },
      { column: 'phone_number', name: 'Phone Number', type: 'input' },
      { column: 'linkedin_url', name: 'LinkedIn URL', type: 'input' },
      { column: 'website_url', name: 'Website URL', type: 'input' },
      { column: 'email', name: 'Email', type: 'input' },
      { column: 'qr_code_link', name: 'QR Code Link', type: 'input' },
      {
        column: 'industry',
        name: 'Industry',
        choices: industries.map(function (industry) {
          return { label: industry, value: industry }
        }),
      },
      { column: 'colors', name: 'Colors', type: 'color' },
      {
        column: 'style',
        name: 'Style',
        choices: [
          { label: 'Sleek / Modern', value: 'modern' },
          { label: 'Classic / Professional', value: 'classic' },
        ],
      },
      { column: 'job_title', name: 'Job Title', type: 'input' },
    ],
  }
}
